export default __webpack_public_path__ + "static/media/pgh_incline.0517836d.jpg";